export const YetakchiAICacheKey = "yetakchi-ai";
